import React, { Component } from 'react'

// sub component
import ReportComponent from './report_component'
import { Empty } from 'antd'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

// ui
import { Row, Col } from 'antd'

class ListInputReports extends Component {
    render() {
        const _reports = this.props.reports
        console.log('data report', _reports)
        return (
            <div className="ListReports">
                <Row>
                    {_reports.length > 0 ? (
                        _reports.map((report, index) => {
                            return (
                                <ReportComponent key={index} report={report} />
                            )
                        })
                    ) : (
                        <Empty
                            description={<span>Không có dữ liệu</span>}
                        ></Empty>
                    )}
                </Row>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        reports: state.qbreport.reports,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListInputReports)
